export default __webpack_public_path__ + "static/media/kpmg.7b12d330.jpg";